<span
	class="obg-standard-regulatory-bar-button"
	test-id="regulatory-header-gambling-summary"
	*ngIf="(showGamblingSummary$ | async) && isAuthenticated"
	(click)="openGamblingSummary('regulatory-bar.gambling-summary')"
>
	<img obgImageContent="general.gambling-summary" />
	<span class="label">{{ 'regulatory-bar.gambling-summary' | jurisdiction | translate }}</span>
</span>

<a
	test-id="regulatory-header-self-assessment"
	*ngIf="showSelfAssessmentButton"
	target="_blank"
	[href]="'general.self-assessment-link' | translate"
	(click)="selfAssessmentClick('regulatory-bar.self-assessment')"
>
	<span class="obg-standard-regulatory-bar-button">
		<img obgImageContent="general.self-test" />

		<span class="label">{{ 'regulatory-bar.self-assessment' | jurisdiction | translate }}</span>
	</span>
</a>

<span
	class="obg-standard-regulatory-bar-button"
	test-id="regulatory-header-deposit-limit"
	*ngIf="showGameLimitsButton"
	(click)="gameLimitsClick('regulatory-bar.gaming-limits')"
>
	<img obgImageContent="general.game-limits" />

	<span class="label">{{ 'regulatory-bar.gaming-limits' | jurisdiction | translate }}</span>
</span>

<span
	class="obg-standard-regulatory-bar-button"
	test-id="regulatory-header-self-exclusion"
	*ngIf="showPanicButton"
	(click)="panicClick('regulatory-bar.self-exclusion')"
	[class.disabled]="isPanicButtonDisabled"
	(mouseenter)="panicButtonMouseEnter()"
	(mouseleave)="panicButtonMouseLeave()"
>
	<img obgImageContent="general.panic" />

	<span class="label">{{ 'regulatory-bar.self-exclusion' | jurisdiction | translate }}</span>
</span>

<obg-timer
	*ngIf="(sessionElapsedSeconds$ | async) as sessionElapsedSeconds"
	[formattableText]="'timer.regulatorybar.text'"
	[elapsedTimeInMillis]="sessionElapsedSeconds"
>
</obg-timer>
